import { useMutation } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { API_URL } from 'src/common/utils/api/fetchWrapper';

export function useUsageMetricsExport() {
  const {
    mutateAsync,
    isPending: isLoading,
    error,
  } = useMutation<void, Error, { includeInternal: boolean }>({
    mutationFn: async ({ includeInternal }) => {
      const response = await fetch(
        `${API_URL}/admin/usage-metrics/export?include_internal=${includeInternal}`,
        { method: 'GET', credentials: 'include' },
      );

      if (!response.ok) {
        throw new Error(`Export download failed: ${response.statusText}`);
      }

      const disposition = response.headers.get('Content-Disposition') ?? '';
      const filename = /filename="?([^";]+)"?/.exec(disposition)?.[1] ?? 'usage-metrics.xlsx';
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = filename;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      URL.revokeObjectURL(url);
    },
    onError: () => {
      notifications.show({
        color: 'red',
        message: 'Could not download the usage metrics spreadsheet',
      });
    },
  });

  return {
    downloadExport: (includeInternal: boolean) =>
      mutateAsync({ includeInternal }).catch(() => undefined),
    isLoading,
    error,
  };
}
